import React from 'react'
import { Box, Container, Flex, Heading, Image, Link, Stack } from "@chakra-ui/react";
import GitHubCalendar from "react-github-calendar";

const GithubStat = () => {
  const githubUsername = "rk6093720";
  
  return (
    <Container
      maxW={{ base: "98%", sm: "80%", lg: "80%" }}
      marginTop={{ base: "100px", md: "130px", lg: "130px" }}
      textAlign={{ base: "center", md: "center", lg: "center" }}
      marginLeft={{ base: "0.2em", sm: "5em", lg: "8em" }}
    >
      <Heading>GitHub Stats</Heading>
      <Stack>
        <Box
          className="react-activity-calendar"
          margin={{ base: "auto", md: "auto", lg: "auto" }}
          marginTop={{ base: "50px", md: "50px", lg: "50px" }}
          marginBottom={{ base: "40px", md: "40px", lg: "40px" }}
          maxW={{ base: "100%", md: "100%", lg: "100%" }}
          overflowX="auto"
        >
          <Link href={`https://github.com/${githubUsername}`} target="_blank" _hover={{ textDecoration: "none" }}>
            <GitHubCalendar
              username={githubUsername}
              blockSize={15}
              blockMargin={5}
              color="hsl(210, 100%, 50%)"
              fontSize={16}
            />
          </Link>
        </Box>
        <Flex
          w={{ base: "100%", md: "100%", lg: "100%" }}
          m="auto"
          justifyContent={{ base: "center", md: "space-around" }}
          marginTop="30px"
          direction={{ base: "column", md: "row", lg: "row" }}
          gap={{ base: "10px", md: "15px" }}
        >
          <Link
            w={{ base: "100%", md: "33%" }}
            href={`https://github.com/${githubUsername}`}
            target="_blank"
            _hover={{ textDecoration: "none" }}
          >
            <Flex justifyContent={"center"}>
              <Image
                id="github-streak-stats"
                src={`https://streak-stats.demolab.io/?user=${githubUsername}&theme=highcontrast`}
                alt="GitHub Streak Stats"
                maxW="100%"
                h="auto"
                fallback={<Box p={4} bg="gray.200" borderRadius="md">Streak stats loading...</Box>}
              />
            </Flex>
          </Link>

          <Link
            w={{ base: "100%", md: "30%" }}
            href={`https://github.com/${githubUsername}`}
            target="_blank"
            _hover={{ textDecoration: "none" }}
          >
            <Flex justifyContent={"center"}>
              <Image
                id="github-top-langs"
                src={`https://github-readme-stats.vercel.app/api/top-langs/?username=${githubUsername}&show_icons=true&locale=en&layout=compact&theme=highcontrast`}
                alt="Top Languages"
                maxW="100%"
                h="auto"
                fallback={<Box p={4} bg="gray.200" borderRadius="md">Languages loading...</Box>}
              />
            </Flex>
          </Link>

          <Link
            w={{ base: "100%", md: "31%" }}
            href={`https://github.com/${githubUsername}`}
            target="_blank"
            _hover={{ textDecoration: "none" }}
          >
            <Flex justifyContent={"center"}>
              <Image
                id="github-stats-card"
                src={`https://github-readme-stats.vercel.app/api?username=${githubUsername}&show_icons=true&locale=en&theme=highcontrast`}
                alt="GitHub Stats Card"
                maxW="100%"
                h="auto"
                fallback={<Box p={4} bg="gray.200" borderRadius="md">Stats loading...</Box>}
              />
            </Flex>
          </Link>
        </Flex>
      </Stack>
    </Container>
  );
}

export default GithubStat